window.LangPack={
    "areg": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "enus": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "eses": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "frfr": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "jajp": {
        "<%=name%>联系我们内容": "@@@@<h3>お問い合わせ</h3>\n\n<p>E-mail：orcalivecs@asiainnovations.com</p>\n\n@@@@<h3>ビジネス提携・協力について</h3>\n<p>E-mail：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": " <%=name%>お問い合わせ"
    },
    "kokr": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "msmy": {
        "<%=name%>联系我们内容": "@@@@<h3>联系我们</h3>\n\n<p>邮箱：orcalivecs@asiainnovations.com</p>\n\n@@@@<h3>商务合作</h3>\n<p>邮箱：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": " <%=name%>联系我们"
    },
    "ptpt": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "ruru": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "thth": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "trtr": {
        "<%=name%>联系我们内容": "@@@@<h3>Contact us</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Business enquires</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": "<%=name%> Contact us"
    },
    "vivn": {
        "<%=name%>联系我们内容": "@@@@<h3>Liên hệ với chúng tôi</h3> <p>Email：orcalivecs@asiainnovations.com</p> @@@@<h3>Hợp tác kinh doanh</h3> <p>Email：orcalivebd@asiainnovations.com</p>",
        "内容扩展-extra<%=name%>": "Phát triển nội dung-extra<%=name%>"
    },
    "zhcn": {
        "<%=name%>联系我们内容": "@@@@<h3>联系我们</h3>\n\n<p>邮箱：orcalivecs@asiainnovations.com</p>\n\n@@@@<h3>商务合作</h3>\n<p>邮箱：orcalivebd@asiainnovations.com</p>",
        "页面标题<%=name%>": " <%=name%>联系我们"
    },
    "zhhk": {
        "<%=name%>联系我们内容": "@@@@<h3>聯繫我們</h3>\n\n<p>郵箱：orcalivecs@asiainnovations.com</p>\n\n@@@@<h3>商務合作</h3>\n<p>郵箱：orcalivebd@asiainnovations.com</p>"
    },
    "zhtw": {
        "<%=name%>联系我们内容": "@@@@<h3>聯繫我們</h3>\n\n<p>郵箱：orcalivecs@asiainnovations.com</p>\n\n@@@@<h3>商務合作</h3>\n<p>郵箱：orcalivebd@asiainnovations.com</p>\n"
    }
}


// WEBPACK FOOTER //
// ./js/lang/contact-show/pack.js